// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import { assign } from 'lodash';
import dispatcher from './dispatcher';
import { genericStoreAction } from './generic-store-reducer';
import { dispatch } from './redux-store';

export interface ILegacyStore {
    state: Object;
    setState(state: Object): void;
    emit(event: string, state: Object): void;
    on(eventName: string, handler: (data?: Object) => void, context?: Object): void;
    off(eventName: string, handler: (data?: Object) => void, context?: Object): void;
}

export interface ILegacyStoreCreator {
    getInitialState(): Object;
    storeWillRegister(): void;
}

let guid = 1;
/**
 * @deprecated
 */
export class LegacyStore implements ILegacyStore {
    private _legacyStoreId: number;
    public state: Object;

    constructor(storeCreator: ILegacyStoreCreator) {
        assign(this, storeCreator);
        this._legacyStoreId = guid++;
        this.state = (this as any).getInitialState();
        (this as any).storeWillRegister();
    }

    private _getLegacyStoreId(): string {
        return `LegacyStore#${this._legacyStoreId}`;
    }

    public setState(changes: Object): void {
        this.state = assign({}, this.state, changes);
        dispatch(genericStoreAction(this._getLegacyStoreId(), this.state));
        this.emit('change', changes);
    }

    public emit(eventName: string, state: Object): void {
        dispatcher.dispatch(`${this._getLegacyStoreId()}_${eventName}`, state);
    }

    public on(eventName: string, handler: (data?: Object) => void, context?: Object): void {
        dispatcher.register(`${this._getLegacyStoreId()}_${eventName}`, handler, context);
    }

    public off(eventName: string, handler: (data?: Object) => void, context?: Object): void {
        dispatcher.unregister(`${this._getLegacyStoreId()}_${eventName}`, handler);
    }
}
